import { render, staticRenderFns } from "./EarlierConsultation.vue?vue&type=template&id=4b3cdef3&scoped=true&"
import script from "./EarlierConsultation.vue?vue&type=script&lang=js&"
export * from "./EarlierConsultation.vue?vue&type=script&lang=js&"
import style0 from "./EarlierConsultation.vue?vue&type=style&index=0&id=4b3cdef3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3cdef3",
  null
  
)

export default component.exports